import authTranslations from "@src/modules/member/modules/main/auth/_langs/en-US";
import clientTranslations from "@src/modules/member/modules/main/clients/_langs/en-US";
import contractTranslations from "@src/modules/member/modules/main/contracts/_langs/en-US";
import dashboardTranslations from "@src/modules/member/modules/main/dashboard/_langs/en-US";
import expenseTranslations from "@src/modules/member/modules/main/expenses/_langs/en-US";
import feesTranslations from "@src/modules/member/modules/main/fees/_langs/en-US";
import formTranslations from "@src/modules/member/modules/main/forms/_langs/en-US";
import invoiceTranslations from "@src/modules/member/modules/main/invoices/_langs/en-US";
import projectTranslations from "@src/modules/member/modules/main/projects/_langs/en-US";
import timeEntryTranslations from "@src/modules/member/modules/main/time-entries/_langs/en-US";
import transactionTranslations from "@src/modules/member/modules/main/transactions/_langs/en-US";

export default {
  auth: authTranslations,
  clients: clientTranslations,
  contracts: contractTranslations,
  dashboard: dashboardTranslations,
  expenses: expenseTranslations,
  fees: feesTranslations,
  forms: formTranslations,
  invoices: invoiceTranslations,
  projects: projectTranslations,
  timeEntries: timeEntryTranslations,
  transactions: transactionTranslations,
  viewChangeLogs: "View Change Logs",
};
